// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__Ut7I8","Content":"Layout_Content__E7f2t"};